(() => {
  const key = 'maison-appearance-v1';
  const root = document.documentElement;
  const update = (mode, persist = false) => {
    root.dataset.maisonMode = mode === 'night' ? 'night' : 'day';
    root.removeAttribute('data-maison-contrast');
    root.style.removeProperty('--maison-contrast-value');
    document.querySelectorAll('maison-appearance [data-mode]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.mode === root.dataset.maisonMode));
    });
    if (persist) {
      try { localStorage.setItem(key, root.dataset.maisonMode); } catch {}
    }
  };
  if (!customElements.get('maison-appearance')) {
    customElements.define('maison-appearance', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.hidden = false;
        update(root.dataset.maisonMode);
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-mode]');
          if (button && this.contains(button)) update(button.dataset.mode, true);
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            this.querySelector('details').open = false;
            this.querySelector('summary').focus();
          }
        }, options);
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) this.querySelector('details').open = false;
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  window.addEventListener('storage', event => {
    if (event.key === key || event.key === null) update(event.newValue);
  });
  window.addEventListener('pageshow', () => {
    try { update(localStorage.getItem(key)); } catch {}
  });
})();
